import React from "react";
import Layout from "../../Components/Layout/Layout";
import Filter from "./../../Components/Filter2";
import Card from "./Components/Card";
import "./responsive.css";

const Organizer = () => {
  return (
    <Layout title="Organizer Communications" page="organizer">
      <div className="container">
        <Filter />
      </div>
      <Card />
      <Card />
    </Layout>
  );
};

export default Organizer;
